<template>
  <a-card :bordered="false">
    <!-- 表格筛选 start -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSubmit">
        <a-row :gutter="48">
          <!-- 输入关键词查找 -->
          <a-col :md="6" :sm="24">
            <a-form-item>
              <!-- 关键字搜索 -->
              <a-input v-model="queryParam.keyWord" placeholder="请输入关键字">
                <!-- 选择搜索类型 -->
                <a-select slot="addonBefore" v-model="queryParam.keyWordType" placeholder="请选择" style="width:100px">
                  <a-select-option :value="item.id" :key="item.id" v-for="item in keyWordTypeDict">{{ item.name }}</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-range-picker :value="time" format="YYYY-MM-DD" @change="onChangeTime" :placeholder="['创建开始日期','创建结束日期']" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-range-picker :value="expiryTime" format="YYYY-MM-DD" @change="onChangeExpiryTime" :placeholder="['到期开始日期','到期结束日期']" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
          </template>
          <!-- 展开或者收起筛选项 start -->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-button style="margin-left: 8px" @click="reset">重置</a-button>
            </span>
          </a-col>
          <!-- 展开或者收起筛选项 end -->
        </a-row>
      </a-form>
    </div>
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="table-operator">
      <a-button type="primary" @click="openAddDrawer" style="margin-right:15px;">新增客户</a-button>
      <a-button type="primary" @click="clickOrderOutExcel" style="margin-right:15px;">导出</a-button>
      <a-radio-group style="float:right" v-model="queryParam.status" @change="handleSubmit">
        <a-radio-button v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
      </a-radio-group>
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <tcg-table
      style="margin-top:20px;"
      ref="table"
      size="default"
      rowKey="tenant_id"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="online" slot-scope="text, record">
        {{ record.online_count }} / {{ record.device_count }}
      </span>
      <span slot="code_type" slot-scope="text">
        {{ text | valInDict(dict.codeTypeDict) }}
      </span>
      <span slot="status" slot-scope="text">
        {{ text | valInDict(dict.statusDict) }}
      </span>
      <span v-if="!record.update_term" slot="expiry_time" slot-scope="text, record">
        {{record.expiry_time}}
      </span>
      <span v-else slot="expiry_time" slot-scope="text, record">
        <a-date-picker
          format="YYYY-MM-DD 23:59:59"
          v-model="record.expiry_time"
          @change="formatTime($event, record)"
        >
          <template slot="renderExtraFooter">
          </template>
        </a-date-picker>
<!--        <a-input type="time">{{record.expiry_time}}</a-input>-->
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="openViewModal(record)">查看</a>
          <a-divider type="vertical" v-if="record.status === 'NORMAL' || record.status === 'FORBIDDEN'"/>
          <a @click="openBackStage(record)" v-if="record.status === 'NORMAL' || record.status === 'FORBIDDEN'">访问后台</a>
          <a-divider type="vertical" v-if="record.status === 'NORMAL' || record.status === 'FORBIDDEN'"/>
          <a @click="record.update_term = true" v-if="user === 'admin' && !record.update_term">变更期限</a>
          <a @click="updateTerm(record)" v-if="user === 'admin' && record.update_term">确认修改</a>
          <a-divider type="vertical" />
          <template>
            <a-dropdown>
              <a class="ant-dropdown-link" href="#">
                更多<a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item v-if="record.status === 'NORMAL'">
                  <a-popconfirm
                    title="确认禁用客户吗？"
                    @confirm="forbiddenChange('FORBIDDEN', record.tenant_id)"
                    okText="确认"
                    cancelText="取消"
                  >
                    <a href="#">禁用</a>
                  </a-popconfirm>
                </a-menu-item>
                <a-menu-item v-if="record.status === 'FORBIDDEN'">
                  <a-popconfirm
                    title="确认启用客户吗？"
                    @confirm="forbiddenChange('NORMAL', record.tenant_id)"
                    okText="确认"
                    cancelText="取消"
                  >
                    <a href="#">启用</a>
                  </a-popconfirm>
                </a-menu-item>
                <!-- <a-menu-item>
                    <a @click="openTimeModal(record)">修改有效期</a>
                  </a-menu-item> -->
                <a-menu-item>
                  <a @click="handlePay(record)">续费</a>
                </a-menu-item>
                <!-- <a-menu-item>
                  <a @click="openDbModal(record)">数据库更新</a>
                </a-menu-item> -->
                <!-- <a-menu-item>
                    <a @click="openConfigModal(record)">系统配置权限</a>
                  </a-menu-item> -->
              </a-menu>
            </a-dropdown>
          </template>
        </template>
      </span>
    </tcg-table>
    <!-- 表格 end -->
    <!-- 查看弹出 -->
    <viewDrawer
      v-if="viewVisible"
      :visible="viewVisible"
      :id="tenantId"
      :detail="tenantDetail"
      @hide="cancelViewDrawer"
      @handlePay="handlePay(tenantId)"/>
    <!-- 添加抽屉 -->
    <addDrawer v-if="addDrawerVisible" :visible="addDrawerVisible" @hide="handelAddDrawer" @finish="finish"></addDrawer>
    <!-- 修改有效期 -->
    <!-- <a-modal
      title="修改有效期"
      :visible="timeVisible"
      @ok="handleTimeOk"
      @cancel="timeVisible = false"
    >
      <p style="margin-left:30px;">客户有效期至：<a-date-picker :default-value="expiryTimeData.expiry_time" @change="onExpiryTimeChange" /></p>
    </a-modal> -->
    <!-- 数据库更新 -->
    <a-modal
      width="750px"
      title="数据库更新"
      :visible="dbVisible"
      v-if="dbVisible"
      @ok="handleDbOk"
      @cancel="dbVisible = false"
    >
      选择SQL文件：<a-select
        style="width:300px;"
        placeholder="请选择SQL文件"
        @change="handleSqlChange">
        <a-select-option v-for="item in dict.sqlpatchDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
      </a-select>
      <p style="margin-top:10px;margin-bottom:10px;">更新内容：</p>
      <a-textarea v-model="sqlContent" :rows="12" />
    </a-modal>
    <!-- 系统配置权限 -->
    <!-- <a-modal
      :width="780"
      title="系统配置权限"
      :visible="configVisible"
      @ok="handleConfigOk"
      @cancel="configVisible = false"
    >
      <a-transfer
        :data-source="mockData"
        :list-style="{
          width: '300px',
          height: '500px',
        }"
        :operations="['可配置', '不可配置']"
        :target-keys="targetKeys"
        :render="item => `${item.title}`"
        @change="handleChange"
      >
        <span slot="notFoundContent">
          没数据
        </span>
      </a-transfer>
    </a-modal> -->
    <!-- 支付面板弹框 -->
    <pay-panel
      style="z-index: 999;"
      v-if="orderPrdData"
      ref="payPanel"
      :order-prd-data="orderPrdData"
      :default-pay-type="curItem.pay_type"
      :price="curItem.payment_amount"
      order-type="PRINT"
      @close="handleFilter"
    />
  </a-card>
</template>
<script>
import {
  getPre,
  getTenantList,
  editMemberTerm,
  tenantForbidden,
  getSqlInfo,
  syncDatabase,
  getMerchantUrl,
  orderPre
} from '@/api/tenant'
import { TcgTable } from '@/components'
import { getUserInfo } from '@/api/account'
import PayPanel from '@/components/PayPanel'
import viewDrawer from './viewDrawer'
import addDrawer from './addDrawer'
import moment from 'moment'
import _ from 'lodash'
const keyWordTypeDict = [
  {
    id: 'code',
    name: '客户编号'
  },
  {
    id: 'name',
    name: '客户名称'
  },
  {
    id: 'contacts',
    name: '联系人'
  },
  {
    id: 'contact_number',
    name: '联系电话'
  }
]
export default {
  components: {
    TcgTable,
    viewDrawer,
    addDrawer,
    PayPanel
  },
  data () {
    return {
      // 添加抽屉状态开关
      addDrawerVisible: false,
      // id
      id: '',
      // 关键字搜索类型列表
      keyWordTypeDict,
      // 字典
      dict: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        status: '',
        keyWordType: 'name',
        keyWord: '',
        start_time: '',
        end_time: '',
        expiry_start_time: '',
        expiry_end_time: ''
      },
      user: '',
      // 表头
      columns: [
        // {
        //   title: 'ID',
        //   dataIndex: 'tenant_id'
        // },
        {
          title: '客户编码',
          dataIndex: 'code'
        },
        {
          title: '客户名称',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '联系人',
          dataIndex: 'contacts'
        },
        {
          title: '联系电话',
          dataIndex: 'contact_number'
        },
        {
          title: '会员类型',
          dataIndex: 'code_type',
          scopedSlots: { customRender: 'code_type' }
        },
        {
          title: '云码数量',
          dataIndex: 'security_code_balance',
          scopedSlots: { customRender: 'security_code_balance' }
        },
        {
          title: '开通时间',
          dataIndex: 'effect_time',
          width: '120px'
        },
        {
          title: '到期时间',
          dataIndex: 'expiry_time',
          width: '120px',
          scopedSlots: { customRender: 'expiry_time' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '最后登录时间',
          dataIndex: 'last_login_time',
          width: '120px'
        },
        {
          title: '业务经理',
          dataIndex: 'business_manager'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: '120px'
        },
        {
          title: '操作',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: '150px'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getTenantList(Object.assign(parameter, this.queryParam))
          .then(res => {
            // 添加一个修改期限状态
            if( res.data != '' && res.data.length > 0 ){
              for (let i=0;i<res.data.length;i++) {
                res.data[i].update_term = false
              }
            }
            return res
          })
      },
      tenantId: 0,
      tenantDetail: {},
      viewVisible: false,
      timeVisible: false,
      expiryTimeData: {
        tenantId: '',
        expiry_time: ''
      },
      dbVisible: false,
      dbData: {
        tenantId: '',
        sqlId: ''
      },
      sqlContent: '',
      configVisible: false,
      configData: {},
      mockData: [],
      targetKeys: [],
      curItem: '',
      orderPrdData: '',
      time: [],
      expiryTime: [],
      code_type: ''
    }
  },
  created () {
    getUserInfo().then((res) => {
      this.user = res.data.account
    })
    this.handelPre()
    this.getOrderPre()
  },
  methods: {
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    moment,
    getOrderPre () {
      orderPre().then(res => {
        console.log(res)
        this.orderPrdData = res.data.annualPriceDict
      })
    },
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict = _.get(res, 'values', {})
        }
      })
    },
    // getMock() {
    //   const mockData = []
    //   for (const i in this.dict.configSettingDict) {
    //     const data = {
    //       key: this.dict.configSettingDict[i].id,
    //       title: this.dict.configSettingDict[i].name
    //     }
    //     mockData.push(data)
    //   }
    //   this.mockData = mockData
    // },
    handleChange(targetKeys, direction, moveKeys) {
      this.targetKeys = targetKeys
    },
    // 重置按钮
    reset () {
      this.queryParam = {
        status: '',
        keyWordType: 'name',
        keyWord: '',
        start_time: '',
        end_time: '',
        expiry_start_time: '',
        expiry_end_time: ''
      }
      this.time = []
      this.expiryTime = []
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.viewVisible = false
      this.$refs.table.refresh(true)
    },
    // 打开查看抽屉
    openViewModal (record) {
      this.tenantId = record.tenant_id
      this.code_type = record.code_type
      this.getDetailOrderPre(this.tenantId)
      this.tenantDetail = {
        name: record.name
      }
      this.viewVisible = true
    },
    // 完成创建
    finish () {
      this.handelAddDrawer()
      this.$refs.table.refresh(true)
    },
    // 打开添加抽屉
    openAddDrawer () {
      this.addDrawerVisible = true
    },
    // 关闭添加抽屉
    handelAddDrawer () {
      this.addDrawerVisible = false
    },
    forbiddenChange (type, tenantId) {
      const data = {
        type: type,
        tenant_id: tenantId
      }
      tenantForbidden(data).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('操作成功')
          this.$refs.table.refresh(true)
        }
      })
    },
    // 选择时间事件
    onChangeTime (dateStrings) {
      this.time = dateStrings
      if (dateStrings.length !== 0) {
        this.queryParam.start_time = dateStrings[0].format('YYYY-MM-DD 00:00:00')
        this.queryParam.end_time = dateStrings[1].format('YYYY-MM-DD 23:59:59')
      } else {
        this.queryParam.start_time = ''
        this.queryParam.end_time = ''
      }
    },
    onChangeExpiryTime(dateStrings) {
      this.expiryTime = dateStrings
      if (dateStrings.length !== 0) {
        this.queryParam.expiry_start_time = dateStrings[0].format('YYYY-MM-DD 00:00:00')
        this.queryParam.expiry_end_time = dateStrings[1].format('YYYY-MM-DD 23:59:59')
      } else {
        this.queryParam.expiry_start_time = ''
        this.queryParam.expiry_end_time = ''
      }
    },
    getDetailOrderPre (tenantId) {
      orderPre({ tenant_id: tenantId }).then(res => {
        this.orderPrdData = res.data.annualPriceDict
      })
    },
    // 续费
    handlePay(item) {
      if (item.tenant_id) {
        this.getDetailOrderPre(item.tenant_id)
        this.$refs.payPanel.showModal(item.tenant_id)
      } else {
        this.getDetailOrderPre(item)
        this.$refs.payPanel.showModal(item)
      }
    },
    openDbModal (record) {
      this.dbData.tenantId = record.tenant_id
      this.sqlContent = ''
      this.dbVisible = true
    },
    handleSqlChange (value) {
      // 获取sql文件信息
      this.dbData.sqlId = value
      getSqlInfo({ sql_id: value }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.sqlContent = _.get(res, 'data.content', '')
        }
      })
    },
    handleDbOk () {
      const data = {
        tenant_id: this.dbData.tenantId,
        sql_id: this.dbData.sqlId
      }
      // console.log(data)
      syncDatabase(data).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('操作成功')
          this.$refs.table.refresh(true)
          this.dbVisible = false
        }
      })
    },
    // openConfigModal (record) {
    //   this.configData.tenantId = record.tenant_id
    //   if (record.config_setting) {
    //     this.targetKeys = record.config_setting
    //   } else {
    //     this.targetKeys = []
    //   }
    //   this.getMock()
    //   this.configVisible = true
    // },
    // 续费

    // 导出
    clickOrderOutExcel () {
      setTimeout(function() {
        window.location.href = window.location.origin + '/admin.php/tenant/outExcel?order_type=ANNUAL'
      }, 1000)
    },
    // 访问后台
    openBackStage (e) {
      const params = {
        tenant_id: e.tenant_id
      }
      getMerchantUrl(params).then(res => {
        if (res.code === 200) {
          window.open(res.data)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    updateTerm (record) {
      record.update_term = false
      const param = {
        expiry_time:record.expiry_time,
        tenant_id:record.tenant_id,
        code_type:record.code_type
      }
      editMemberTerm(param).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })

    },
    formatTime (event, record) {
      var date = new Date(event._d)
      record.expiry_time = date.toLocaleDateString().replace(/\//g,'-') + ' 23:59:59'
    }
    // handleConfigOk () {
    //   const data = {
    //     tenant_id: this.configData.tenantId,
    //     config_setting: this.targetKeys
    //   }
    //   configSetting(data).then(res => {
    //     if (_.get(res, 'code') === 200) {
    //       this.$message.success('操作成功')
    //       this.$refs.table.refresh(true)
    //       this.configVisible = false
    //     }
    //   })
    // }
  }
}
</script>
<style lang="less" scoped>
</style>
